import fornecedoresMenu from '../fornecedor/contratos/menu'
import financeiroMenu from './financeiro/menu'
import convenioMenu from './convenios/menu'
import aprovadoresMenu from './aprovadores/menu'
import gestoresMenu from './gestores/menu'
import gerentesMenu from './gerentes/menu'


export default {
    name: 'GESCON',
    url: '/gescon',
    icon: 'fa fa-book',
    regras: [
        ...fornecedoresMenu.map(r => r.regras),
        ...financeiroMenu.map(r => r.regras),
        ...convenioMenu.map(r => r.regras),
        ...aprovadoresMenu.map(r => r.regras),
        ...gestoresMenu.map(r => r.regras),
        ...gerentesMenu.map(r => r.regras)
    ],
    children: [...fornecedoresMenu, ...gestoresMenu, ...gerentesMenu, ...financeiroMenu, ...convenioMenu, ...aprovadoresMenu]
}
